// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"46":"f9b77146","453":"f9734d56"}[chunkId] + ".chunk.js";
};